<template>
  <ul class="rt-infos" id="rt-infos-id">
    <li v-for="(newsInfo, index) in currTypeList" v-bind:key="index" style="margin: 0px;">
      <NewsTplRightSingle v-if="newsInfo.provider === 'df'" v-bind:newsInfo="newsInfo"></NewsTplRightSingle>
      <!-- <NewsTplRightAdBaidu v-if="newsInfo.provider === 'bdwm' && newsInfo.show" v-bind:newsAdInfo="newsInfo" v-bind:compName="compName" v-bind:pageType="pageType"></NewsTplRightAdBaidu> -->
      <NewsTplRightAd360 v-if="newsInfo.provider === '360' && newsInfo.show" v-bind:newsAdInfo="newsInfo" v-bind:compName="compName" v-bind:pageType="pageType"></NewsTplRightAd360>
    </li>
  </ul>
</template>
<script>
import news from '../../api/news';
import NewsTplRightSingle from '../NewsTpl/NewsTplRightSingle';
import NewsTplRightAdBaidu from '../NewsTpl/NewsTplRightAdBaidu';
import NewsTplRightAd360 from '../NewsTpl/NewsTplRightAd360';
import _ from 'lodash';
import ad from '../../api/ad';
import filter from '../../api/filter.js';

export default {
  name: 'EntNews',
  components: {
    NewsTplRightSingle,
    NewsTplRightAdBaidu,
    NewsTplRightAd360
  },
  mounted () {
    this.$bus.$on('showReport', (data) => {
      this.iframeRect = data.rect;
    });
    this.$bus.$on('refreshRight',  _.debounce((data) => this.loadNewsData(data), 50));
  },
  props: ['compsCfg', 'pageType'],
  data () {
    return {
      compName: 'EntNews',
      currTypeList: [],
      newsList: [],
      curType: '',
      curNewsCnt: 0,
      reqTimes: 0,
      intBaiduAdCnt: 0,
      iframeRect: {
        stop: 0,
        wheight: 0
      }
    };
  },
  methods: {
    loadNewsData (data) {
      let needNewsCnt = this.calcNewsCnt(data.curType), reqNewsCnt = 0;
      if (needNewsCnt > this.curNewsCnt) {
        reqNewsCnt = needNewsCnt - this.curNewsCnt;
      } else {
        this.currTypeList = this.newsList.slice(0, needNewsCnt);
      }
      if (reqNewsCnt > 0) {
        let params = {
          newsnum: reqNewsCnt,
          qid: this.compsCfg.newsList.params.qid,
          type: 'yule',
          startkey: '',
          pgnum: 1,
          fnName: 'getEntList',
          report: {
            click_report: (this.compsCfg.newsList['click_report'] || 'Click_News_right')
          }
        };
        // 错误页接入导航版数据
        // let newsType = (this.pageType == 'errorpage') ? 'df_2345_right' : this.compsCfg.newsList.type;
        // 接入东方数据
        let newsType = this.compsCfg.newsList.type;
        news.getList(newsType, params, (err, res) => {
					// console.log(res)
          if (err) {
            console.log('EntNews getList err', err);
          } else {
            // 过滤新闻敏感词
            filter.filterWithPath(res, 'data.(*).title');
            let newsData = res.data, adCfg = this.compsCfg.ad, intAdCnt = 0, oldNewsCnt = this.newsList.length;
            let arrLoadAdsIdx = [];
            this.reqTimes += 1;
            res.data.forEach((newsItem, index) => {
              let adsIdx = 'EntNews_' + adCfg.type + '_' + index + '_' + (Math.random() + '').replace('.', '');
              if (adCfg.type === 'bdwm') {
                if ((index + 1) % 4 === 0) {
                  newsData.splice(index, 1, {
                    itemType: 'bdwm',
                    divId: adsIdx,
                    provider: 'bdwm',
                    show: true,
                    show_report_50bang: adCfg.show_report,
                    uid: adCfg.uuid[(intAdCnt + adCfg.uuid.length) % adCfg.uuid.length]
                  });
                  intAdCnt++;
                }
              } else if (adCfg.type === '360') {
                if ((index + 1) % 4 === 0) {
                  arrLoadAdsIdx.push(index + oldNewsCnt);
                }
              }
            });
            this.newsList = this.newsList.concat(newsData);
            this.currTypeList = this.newsList.slice(0, needNewsCnt);
            this.curNewsCnt = this.newsList.length;
            arrLoadAdsIdx.length > 0 && this.loadAdsList(arrLoadAdsIdx, adCfg, this.reqTimes);
            setTimeout(() => {
              this.$bus.$emit('showRight', {
                rect: this.iframeRect
              });
            }, 300);
          }
        });
      }
    },
    calcNewsCnt (type) {
      let intRet = 0;
      let newsCntHeight = document.querySelector('ul#' + type).offsetHeight;
      let adsChuangHeight = (document.querySelector('.rt-site2') ? document.querySelector('.rt-site2').offsetHeight : 0);
      intRet = Math.floor((newsCntHeight - adsChuangHeight) / 74);
      return (intRet + 20);
    },
    loadAdsList (arrLoadAdsIdx, adCfg, reqTimes) {
       ad.getAdsList(adCfg.type, {
         showid: adCfg.uuid[0],
         reqtimes: reqTimes,
         impct: arrLoadAdsIdx.length,
         queryword: '',
         cname: '娱乐'
       }, (err, list) => {
          if (err || !list || !list['ads']) {
            console.log('EntNew loadAdsList err', arrLoadAdsIdx, adCfg, reqTimes);
          } else {
            list.ads.forEach((adsInfo, idx) => {
              this.newsList[arrLoadAdsIdx[idx]].show = true;
              this.newsList[arrLoadAdsIdx[idx]].provider = '360';
              this.newsList[arrLoadAdsIdx[idx]].itemType = '360';
              this.newsList[arrLoadAdsIdx[idx]].divId = 'EntNews_' + adCfg.type + '_' + arrLoadAdsIdx[idx] + '_' + (Math.random() + '').replace('.', '');
              this.newsList[arrLoadAdsIdx[idx]].url = adsInfo.curl;
              this.newsList[arrLoadAdsIdx[idx]].show_report_50bang = adCfg.show_report || 'Error_AdShow_360_Right';
              this.newsList[arrLoadAdsIdx[idx]].click_report_50bang = adCfg.click_report|| 'Error_AdClick_360_Right';
              this.newsList[arrLoadAdsIdx[idx]].uid = adCfg.uuid[0];
              this.newsList[arrLoadAdsIdx[idx]].miniimg[0]['src'] = adsInfo.img;
              this.newsList[arrLoadAdsIdx[idx]].topic = adsInfo.title;
              this.newsList[arrLoadAdsIdx[idx]].imptk = adsInfo.imptk;
              this.newsList[arrLoadAdsIdx[idx]].clktk = adsInfo.clktk;
            });
            setTimeout(() => {
              this.$bus.$emit('showReport', {
                rect: this.iframeRect
              });
            }, 100);
          }
       })
    }
  }
}
</script>
